<template>
  <div>
    <!-- Comments section -->
    <v-card v-if="commentsFound && commentsFound.length" class="mb-3" border>
      <v-list density="compact">
        <v-list-item
          v-for="comment in commentsFound"
          :key="comment.id"
          :to="comment.start !== null ?
            { path: '/pod/' + pod.id, query: { start: comment.start, menu: 'comments' }} :
            { path: '/pod/' + pod.id, query: { menu: 'comments' }}"
          role="listitem"
        >
          <v-list-item-title>
            {{ truncateText(comment.content, 36) }}
            <span v-if="comment.start !== null" class="text-grey-darken-1">
              | {{ videoDuration(comment.start / 1000) }}
            </span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>

    <!-- Labels section -->
    <v-card v-if="labelsFound.length > 0" class="mb-3" border>
      <v-list density="compact">
        <v-list-item
          v-for="label in labelsFound"
          :key="label.id"
          :to="typeof label.start === 'number' ?
            { path: '/pod/' + pod.id, query: { type: label.type, start: label.start, menu: 'labels' }} :
            { path: '/pod/' + pod.id, query: { menu: 'labels' }}"
          role="listitem"
        >
          <v-list-item-title>
            {{ truncateText(label.content, 36) }}
            <span v-if="typeof label.start === 'number'" class="text-grey-darken-1">
              | {{ videoDuration(label.start / 1000) }}
            </span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>

    <!-- Transcripts section -->
    <v-card v-if="transcriptsFound && transcriptsFound.length" class="mb-3" border>
      <v-list density="compact">
        <v-list-item
          v-for="transcript in transcriptsFound"
          :key="transcript.id"
          :to="transcript.start !== null ?
            { path: '/pod/' + pod.id, query: { start: transcript.start, menu: 'subtitles', aid: transcript.assetid }} :
            { path: '/pod/' + pod.id, query: { menu: 'subtitles', aid: transcript.assetid }}"
          role="listitem"
        >
          <v-list-item-title>
            {{ truncateText(transcript.content, 36) }}
            <span v-if="transcript.start !== null" class="text-grey-darken-1">
              | {{ videoDuration(transcript.start / 1000) }}
            </span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { truncateText, videoDuration } from '@/components/formatters.js';

export default {
  name: "PodItemSearchresults",
  methods: { truncateText, videoDuration },
  props: {
    pod: {
      type: Object,
      required: true,
    }
  },
  computed: {
    commentsFound() {
      if (this.pod.comment) {
        return this.pod.comment;
      }

      return false;
    },
    labelsFound() {
      const labels = [];
      if (Array.isArray(this.pod?.label) && this.pod.label.length > 0) {
        labels.push(...this.pod.label);
      }

      if (Array.isArray(this.pod?.mllabel) && this.pod.mllabel.length > 0) {
        labels.push(...this.pod.mllabel.map((item) => {
          return {
            id: item.id,
            content: item.content,
            start: item.start,
            end: item.end,
            type: 'label',
          };
        }));
      }

      if (Array.isArray(this.pod?.mltext) && this.pod.mltext.length > 0) {
        labels.push(...this.pod.mltext.map((item) => {
          return {
            id: item.id,
            content: item.content,
            start: item.start,
            end: item.end,
            type: 'text',
          };
        }));
      }

      return labels;
    },

    transcriptsFound() {
      const transcripts = [];

      if (this.pod?.asset?.srt && Array.isArray(this.pod?.asset?.srt)) {
        for (const subtitlesAsset of this.pod.asset.srt) {
          if (Array.isArray(subtitlesAsset?.sentences) && subtitlesAsset.sentences.length > 0) {
            transcripts.push(...subtitlesAsset.sentences);
          }
        }
      }

      if (this.pod?.asset?.vtt && Array.isArray(this.pod?.asset?.vtt)) {
        for (const subtitlesAsset of this.pod.asset.vtt) {
          if (Array.isArray(subtitlesAsset?.sentences) && subtitlesAsset.sentences.length > 0) {
            transcripts.push(...subtitlesAsset.sentences);
          }
        }
      }

      return transcripts || null;
    },
  }
};
</script>

<style scoped>
.v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.03);
}
</style>
